import { Action, createAction, props } from '@ngrx/store';

import { Association, AssociationStatusConfiguration, Candidate } from '@shared/models';
import { Pagination } from '@shared/pagination';
import { ApiParams } from '@shared/services';

export const associateCandidates = createAction(
  '[Assign] Associate Candidates',
  props<{
    associations: Partial<Association>[];
    totalMatchesAssign?: boolean;
    actions?: Action[];
    batchOperation?: boolean;
  }>(),
);

export const associateManyJobs = createAction(
  '[Assign] Associate Many Jobs',
  props<{
    associations: Partial<Association>[];
    totalMatchesAssign?: boolean;
    actions?: Action[];
    batchOperation?: boolean;
  }>(),
);

export const associateCandidatesSuccess = createAction(
  '[Assign] Associate Candidates Success',
  props<{ associations: Association[]; totalMatchesAssign?: boolean }>(),
);

export const associateManyJobsSuccess = createAction(
  '[Assign] Associate Many Jobs Success',
  props<{ associations: Partial<Association>[] }>(),
);

export const associateManyJobsFail = createAction(
  '[Assign] Associate Many Jobs Fail',
  props<{ error: any; associationsSize: number }>(),
);

export const assignCandidatesLoad = createAction(
  '[Assign] Candidates Load',
  props<{
    params?: ApiParams;
    filters?: string[];
    countCandidates?: boolean;
    selectedStatuses?: string[];
    hmSelectedStatuses?: string[];
  }>(),
);

export const loadTotalElements = createAction(
  '[Assign] Candidates total elements Load',
  props<{ params?: ApiParams; filters?: string[]; hmFilters?: string[] }>(),
);

export const setTotalNumberOfCandidatesAndProspects = createAction(
  '[Assign] set total elements',
  props<{ totalAllCandidates: any; totalProspects: any }>(),
);

export const assignedRejectedCandidatesLoad = createAction(
  '[Assign] Rejected Candidates Load',
  props<{ params?: ApiParams; filters?: string[] }>(),
);

export const assignRejectedCandidatesLoadSuccess = createAction(
  '[Assign] Rejected Candidates Load Success',
  props<{ payload: Pagination<Candidate> }>(),
);

export const assignCandidatesLoadSuccess = createAction(
  '[Assign] Candidates Load Success',
  props<{ payload: Pagination<Candidate> }>(),
);

export const assignCandidatesLoadFail = createAction(
  '[Assign] Candidates Load Fail',
  props<{ error: any }>(),
);

export const assignedRejectedCandidatesLoadFail = createAction(
  '[Assign] Rejected Candidates Load Fail',
  props<{ error: any }>(),
);

export const assignCandidatesList = createAction(
  '[Assign] Candidates List',
  props<{ payload: Pagination<Candidate> }>(),
);

export const assignCandidatesClear = createAction('[Assign] Candidates Clear');

export const associationsList = createAction(
  '[Assign] Associations List',
  props<{ payload: Pagination<Association> }>(),
);

export const associationStatusConfigurationsLoad = createAction(
  '[Assign] Association Status Configurations Load',
  props<{ jobId?: number | string }>(),
);

export const getJobAssociationStatusConfigurations = createAction(
  '[Assign] Get Association Status Configurations',
  props<{ jobId?: number | string }>(),
);

export const associationStatusConfigurationsLoadSuccess = createAction(
  '[Assign] Association Status Configurations Load Success',
  props<{ jobId?: number | string; configurations: AssociationStatusConfiguration[] }>(),
);

export const associationStatusConfigurationsLoadFail = createAction(
  '[Assign] Association Status Configurations Load Fail',
  props<{ error: any }>(),
);

export const associationsClear = createAction('[Assign] Associations Clear');
